import { frenchMovies, frenchMoviesForEnUs } from '../data/frenchMovies/frenchMovies.data';
import { MoviesTagPageContent } from '../MoviesTagPageContent';
import { TagPageProps } from '../types/tagPageProps';

export const Content = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={frenchMovies} />
);

export const ContentEnUs = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={frenchMoviesForEnUs} />
);
